import axios from "axios";

export const state = {
    expenses: [],
};

export const getters = {
    expenses: state => state.expenses,
};

export const mutations = {
    setExpenses(state, newValue) {
        state.expenses = newValue
    },
};

export const actions = {
    async fetchExpenses({ commit, rootState }) {
        const fyear = rootState.financialyears.currentFinancialYear;
        await axios.get(`/expenses/${fyear}`).then(res => {
            commit('setExpenses', res.data.expenses)
        })
    },
};
